export const getCountryFromLocale = (locale) => {
  const country = locale.split('-')[1]

  return country.toLocaleLowerCase()
}
